namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.LineTerminationReportGrid')
    export class LineTerminationReportGrid extends Serenity.EntityGrid<LineTerminationReportRow, any> {
        protected getColumnsKey() { return LineTerminationReportColumns.columnsKey; }
        protected getDialogType() { return LineTerminationReportDialog; }
        protected getIdProperty() { return LineTerminationReportRow.idProperty; }
        protected getInsertPermission() { return LineTerminationReportRow.insertPermission; }
        protected getLocalTextPrefix() { return LineTerminationReportRow.localTextPrefix; }
        protected getService() { return LineTerminationReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel', grid: this, service: LineTerminationReportService.baseUrl + '/ListExcel', onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }

    }
}